module.exports = __webpack_public_path__ + "static/media/js_icon.8398c373.svg";